import Page from 'component/Page';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectCurrentUser } from 'redux/user/user.selector';
import sendRequest, {
	sendPost,
	sendPut
} from 'util/request';
import Paths from 'util/paths';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import {
	formatDate,
	nNU,
	showConfirm,
	showToast,
	getParams
} from 'util/utils';

// export const accountRoleNameMap = {
//   0: string.ACCOUNT_ROLE_ADMIN,
//   1: string.ACCOUNT_ROLE_PARENT,
//   2: string.ACCOUNT_ROLE_CHILD,
// };

// export const accountStatusNameMap = {
//   true: string.ACTIVE,
//   false: string.INACTIVE,
// };

const PocChannelAddHost = ({data = {groupId: null}}) => {
  //-------------------------------HOOKS-------------------------------------------------------------
	const params = getParams();
	const currentUser = useSelector(selectCurrentUser);
	const groupId = data.groupId || params?.groupId || params?.id;
	const [selectedChannel, setSelectedChannel] = useState(groupId);
	const [channelData, setChannelData] = useState({});
	const [channelMember, setChannelMember] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [currentUser.accountRole],
  );
	const [selectedItem, setSelectedItem] = useState([]);
	const history = useHistory();
	const headers = isAdmin ? [
		string.POC_LOGIN_ID,
		string.POC_DISPLAY_NAME,
		// string.POC_ACCOUNT_SIP,
		string.POC_ACCOUNT_OWNER,
		string.POC_ACCOUNT_STATUS,
		string.POC_ACCOUNT_REGISTERED_DATE,
	] : [
		// string.POC_LOGIN_ID,
		string.POC_DISPLAY_NAME,
		string.POC_ID,
		// string.POC_ACCOUNT_STATUS,
		// string.POC_ACCOUNT_REGISTERED_DATE,
	];

  //------------------------------FUNCTIONS----------------------------------------------------------
	useEffect(() => {
		if (!selectedChannel) {
			return;
		}
    sendRequest({
      url: `${Urls.pocchannel.channel}/${selectedChannel}`,
    }).then((response) => {
      const { result } = response;
      setChannelData(result);
    });
	},[selectedChannel]);

	const doSearch = useCallback(
		async (page, pageSize, getAll = false) => {
			if (channelData?.type !== 'professional') {
				return;
			}
      let data = await sendPost({
        url: Urls.pocaccount.member,
        body: {
          id: channelData.groupId,
					onlyMember: true,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: '',
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setChannelMember(result);
        setTotal(total);
      }
      return result;
		},
		[channelData]
	);
  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
				key: raw.id,
				data: isAdmin ? [
					raw.username,
					raw.displayName,
					raw.pocId.toString().padStart(6, '0'),
					// (raw.role === 'premium') ? 'プレミアム' : 'トライヤル',
					// raw.sipNumber,
					nNU(raw.email) && raw.email.length > 0 ? raw.email : currentUser.email,
					(raw.status === 1) ? '有効' : '無効',
					formatDate(raw.registerDate, 'YYYY/MM/DD'),
				] : [
					// raw.username,
					raw.displayName,
					raw.pocId.toString().padStart(6, '0'),
					// (raw.role === 'premium') ? 'プレミアム' : 'トライヤル',
					// nNU(raw.email) ? raw.email : '-',
					// (raw.status === 1) ? '有効' : '無効',
					// formatDate(raw.registerDate, 'YYYY/MM/DD'),
				],
				raw,
			})),
    [],
  );

	const onSelect = (e) => {
    let { raw } = e;
    let arr;
    let idx = -1;
    selectedItem?.forEach((item, index) => {
      if (item.pocId === raw.pocId) {
        idx = index;
        return;
      }
    });
    if (idx > -1) {
      let { [idx]: itm, ...rest } = selectedItem;
      arr = Object.values(rest);
    } else {
      // arr = [...selectedItem, raw];
			arr = [raw];
    }
    setSelectedItem(arr);
	};
	const actions = [
		({ raw }) => {
			if (raw.status !== 1) {
				return;
			}
      let idx = -1;
      selectedItem?.forEach((item, index) => {
        if (item.pocId === raw.pocId) {
          idx = index;
          return;
        }
      });
      return selectedItem.indexOf(raw.pocId) > -1
        ? null
        : {
            render: idx > -1 ? 'hostselected' : 'hostselect',
            onClick: onSelect,
          };
		},
	];
	const onAddHost = () => {
		if (selectedItem.length < 1) {
			return;
		}
		let data = {
			groupId: channelData.groupId,
			groupName: channelData.groupName,
			status: channelData.status,
			type: 2,//channelData.type,
			expirationDate: channelData.expirationDate,
			adminId: selectedItem[0].pocId,//selectedItem.map(item => item.pocId),
		};
		showConfirm({
			body: string.POC_CHANNEL_HOST_ADD_CONFIRM,
			defaultAction: () => {
				sendPut({
					url: Urls.pocchannel.update,
					body: data,
				}).then((res) => {
					showToast(string.POC_CHANNEL_HOST_ADD_SUCCESS, 'success');
					// doSearch(page, pageSize);
					history.push(`${Paths.pocchannel.host}/?id=${channelData.groupId}`);
				}).catch((e) => {
					console.log('削除エラー');
				});
			},
		});
	};
	const mainActions = (total > 0) ? [
		{
			icon: 'assign',
			title: string.ADD,
			onClick: () => onAddHost(),
		},
		// {
		// 	icon: 'none',
		// 	title: string.SELECT_ALL,
		// 	onClick: () => setSelectedItem(channelMember),
		// },
		// {
		// 	icon: 'none',
		// 	title: string.UN_SELECT_ALL,
		// 	onClick: () => setSelectedItem([]),
		// },
	] : null;


  //-------------------------------RETURN------------------------------------------------------------
	return (
		<>
			<Page
        title={ nNU(channelData?.groupName) && `${string.POC_CHANNEL_MANAGEMENT} > ${channelData?.groupName} ${string.POC_CHANNEL_HOST_ADD}` }
				body={
					<>
						<Table
							className="nowrap"
							mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={ headers }
              data={dataTable(channelMember)}
              isPaging={true}
							actions={actions}
							selectedCount={selectedItem.length}
						/>
					</>
				}
			/>
		</>
	);
};

export default PocChannelAddHost;
